import Vue from 'vue'
import App from './App.vue'
import router from './router'
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import $ from 'jquery'
import Vue2OrgTree from 'vue2-org-tree'
import '@/assets/icon/iconfont.css'
Vue.use(Vue2OrgTree)
Vue.use(MuseUI)
import theme from 'muse-ui/lib/theme'
theme.add('mytheme', {
  secondary: '#2b1d1a',
  success: '#932120',
}, 'light')
theme.use('mytheme')
import './assets/css/common.css'
import { get, post, getData } from '@/api/https'
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$getData = getData
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)



Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')